export const USER_KEY = 'deal-packet-user';
export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const LOGIN_REMEMBER_ME = 'loginData';
